import React from "react";

export class Search extends React.Component<{className:string}>{
    render(): React.ReactNode {
        return (
           
               <div>
              
            </div>
        )
    }
}